export default [
  {
    name: 'Revisión de la Política (ANEXO 2) y cumplimiento de objetivos de calidad.',
  },
  {
    name: 'Informes de la función metrológica respecto a los indicadores de gestión, así como resultados de recepción, almacenamiento y ventas de combustibles. (PRO-SGMES-EMP-009)',
  },
  {
    name: 'Cumplimiento del programa de confirmación metrológica del Sistema de Gestión de Medición. (ANEXO 9)',
  },
  {
    name: 'Acciones correctivas  (FOR-SGMES-EMP-013) y preventivas  (FOR-SGMES-EMP-015)',
  },
  {
    name: 'Reportes de balances volumétricos (FOR-SGMES-EMP-028)',
  },
  {
    name: 'Evaluaciones por organismos externos. (PRO-SGMES-EMP-002)',
  },
  {
    name: 'Recomendaciones para la mejora. (PRO-SGMES-EMP-007)',
  },
  {
    name: 'Cumplimiento de capacitación del personal y actualizaciones del personal  (FOR-SGMES-EMP-012)',
  },
  {
    name: 'Programas de mantenimiento preventivo, correctivo. (ANEXO 9)',
  },
  {
    name: 'Estatus del comportamiento del equipo de medición e instrumentos (FOR-SGMES-EMP-014)',
  },
  {
    name: 'Programa de auditorías internas y resultados. (FOR-SGMES-EMP-016)',
  },
  {
    name: 'Manejo de quejas. (FOR-SGMES-EMP-026)',
  },
  {
    name: 'Enfoque de mejora continua en sus procesos de medición. (MAN-SGMES-EMP-001)',
  },

]